module.exports = __webpack_public_path__ + "img/search.f7fe4c34.svg";